<template>
  <div class="Feedback-container">
    <div class="crumbs clearfix">
        <router-link
            tag="div"
            class="item fl cur"
            :to="{
    path: '/reconciliation/detail',
    query: {
      khqrzt: '全部',
      vunitname: UNITNAME,
      custcode: CUSTCODE
    }
  }">
        <img class="location" src="@/assets/images/icon_dw_h@2x.png" alt="">
        <span class="text1">对账函列表</span>
      </router-link>
      <span class="text2">对账函</span>

    </div>
    <!--   <h1>{{UNITNAME}}的对账函</h1> 主要内容-->
    <div class="main">

      <div class="pdf-container">
        <iframe :src="FJURL" width="100%" height="500px" class="pdf-frame"></iframe>
        <div class="watermark-overlay" :style="{'background-image': 'url(' + watermarkDataURL + ')'}"></div>
      </div>
      <div class="form" v-if="isKhqr">
        <div class="clearfix">
          <div class="custom-kv clearfix" style="float:left;">
            <div class="key">对账结果：</div>
            <select class="selected" v-model="selected">
              <option value="" disabled selected>请选择</option>
              <option v-for="option in options" :value="option.value" :key="option.value">
                {{ option.text }}
              </option>
            </select>

          </div>
          <div class="custom-kv clearfix">
            <div class="key">对账不符描述：</div>
            <div class="val">
              <div class="custom-textarea">
                <textarea v-model="content" name="content" id="content" cols="30" rows="10" placeholder="对账不符时必须输入不符描述"></textarea>
              </div>
            </div>
          </div>
          <div class="" v-if="isKhqr">
            <button class="submit cur" @click="saveAndQz">签字确认</button>
          </div>
          <div class="" v-if="!isKhqr">
            <button class="submit cur" @click="downloadPdf">对账单下载</button>
          </div>
        </div>



      </div>
    </div>
    <ReminderDialog4 ref="reminderDialog4" type=""></ReminderDialog4>
  </div>
</template>

<script>
import ReminderDialog4 from "@/components/dialogs/ReminderDialog4";
export default {
  name: "DzdMx",
  data() {
    return {
      sklist: [],
      fhlist: [],
      CUSTCODE:"",
      CUSTNAME: "",
      UNITNAME: "",
      BEGINDATE:"",
      KHQRZT:"",
      ENDDATE:"",
      FJURL:"",
      FILENAME:"",
      YUEDX:"",
      VFHDS:"",
      isKhqr:"",
      KHDJJG:"",
      content:"",
      selected: '', // 绑定到选中的值
      options: [ // 下拉列表的选项
        { text: '相符', value: '相符' },
        { text: '不相符', value: '不相符' }
      ],
      watermarkText: '',
      fontSize: '24px',
      color: 'rgba(0,0,0,0.1)',
      angle: 30,
      watermarkDataURL: ''
    };
  },
  components: {ReminderDialog4},
  props: {},
  created() {
    this.date= this.getNowFormatDate();
    this.customer=this.$store.state.name

  },
  computed: {
    pdfUrl() {
      // 多个参数用 & 连接
      return `${this.FJURL}#toolbar=0&navpanes=0&scrollbar=0`
    }
  },
  mounted() {
    this.getDzxmx();
    this.applyWatermark();

    // 防止用户通过开发者工具删除水印
    setInterval(() => {
      this.applyWatermark();
    }, 1000);
  },
  methods:{
    checkHandle(val) {
      this.checkedTypes.splice(0, this.checkedTypes.length - 1)
    },
    async getDzxmx() {
      let res = await this.$api.getDzhDetail({
        bindid: this.$route.query.bindid,
      });
      if (res.code == 1) {
        this.CUSTNAME = res.data.CUSTNAME;
        this.UNITNAME = res.data.UNITNAME;
        this.BEGINDATE = res.data.BEGINDATE;
        this.ENDDATE = res.data.ENDDATE;
        this.YUE = res.data.YUE;
        this.YUEDX = res.data.YUEDX;
        this.VFHDS = res.data.VFHDS;
        this.FJURL = res.data.FJURL;
        this.KHQRZT = res.data.KHQRZT;
        this.KHDJJG = res.data.KHDJJG;
        this.CUSTCODE = res.data.CUSTCODE;

        this.FILENAME = res.data.FILENAME;
        this.fhlist = res.data.fhlist;
        this.sklist = res.data.sklist;
        this.content = res.data.CONTENT;
        this.selected = res.data.KHDZJG;
        this.isKhqr = this.KHQRZT == '未确认';
        if ( this.KHQRZT=='已确认' && this.selected=='相符'){
            this.watermarkText = "客户确认无误    "+this.CUSTNAME;
        }else if(this.KHQRZT=='已确认' && this.selected=='不相符'){
          this.watermarkText = "客户已确认   确认结果不相符";
        }else{
            this.watermarkText = "未签字确认   内容仅供参考";
        }


      } else {
        this.$message.error(res.msg);
      }
    },
    goToALLDetail() {
      this.$router.push({
        path: 'detail',
        query: {
          vunitname: this.$route.query.vunitname,
          khqrzt:'全部',
          custcode: this.$route.query.custcode
        }
      });
    },
    async saveDzdmx() {
      if (!this.selected) return this.$message.error("请输入对账结果")

      this.showLoading("加载中...");
      let res = await this.$api.saveDzjg({
        bindid: this.$route.query.bindid,
        selected: this.selected,
        content: this.content,
      });
      this.closeLoading();
      if (res.code == 1) {

        this.$refs.reminderDialog4.open()
      } else {
        this.$message.error(res.msg);
      }
    },
    async downloadPdf() {
      try {
        // 方法1: 直接创建a标签下载
        const link = document.createElement('a');
        link.href = this.FJURL;
        link.download = this.FILENAME;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 或者方法2: 使用fetch（适用于需要添加认证头部的场景）
        // await this.downloadWithFetch();

      } catch (error) {
        console.error('下载失败:', error);
        this.$message.error('文件下载失败，请重试');
      }
    },
    createWatermark() {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // 设置canvas大小
      canvas.width = 400;
      canvas.height = 300;

      // 清除画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // 设置字体样式
      ctx.font = `bold ${this.fontSize} Arial`;
      ctx.fillStyle = this.color;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      // 旋转文字
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate(-this.angle * Math.PI / 180);
      ctx.translate(-canvas.width / 2, -canvas.height / 2);

      // 绘制水印文字
      ctx.fillText(this.watermarkText, canvas.width / 2, canvas.height / 2);

      return canvas.toDataURL('image/png');
    },
    applyWatermark() {
      this.watermarkDataURL = this.createWatermark();
    },
    resetWatermark() {
      this.watermarkText = '机密文档 - 请勿外传';
      this.fontSize = '24px';
      this.color = 'rgba(0,0,0,0.1)';
      this.angle = 30;
      this.applyWatermark();
    },

    async saveAndQz() {
      // 检查是否选择了对账结果
      if (!this.selected) {
        this.$message.error("请选择对账结果");
        return;
      }

      // 如果选择"不相符"，必须填写描述
      if (this.selected === '不相符') {
        if (!this.content || this.content.trim() === '') {
          this.$message.error("请输入对账不符描述");
          return;
        }
      }

      this.showLoading("加载中...");
      let res = await this.$api.saveDzjgAndConfirm({
        bindid: this.$route.query.bindid,
        selected: this.selected,
        content: this.content,
      });
      this.closeLoading();
      if (res.code == 1) {
        this.checkedTypes = [];
        window.location.href = res.msg;
      } else {
        this.$message.error(res.msg);
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.pdf-container {
  position: relative;
  overflow: hidden;
  height: 560px;
}

.pdf-frame {
  position: absolute;
  top: -40px; /* 向上偏移隐藏工具栏 */
  height: 600px; /* 增加高度补偿偏移 */
  border: none;
}
.Feedback-container {
  min-height: $main-height;

  .cover {
    height: 200px;
    background-size: auto 100%;
    @media (max-width:1600px){
      height: 120px;
    }
  }

  .main {
    width: 1200px;
    margin: 20px auto;

    > .header {
      height: 60px;
      background: $color-primary;
      padding-left: 20px;
      position: relative;

      img {
        width: 20px;
        @include cv;
      }

      span {
        line-height: 60px;
        margin-left: 30px;
        font-size: 16px;
        color: #FFFFFF;
      }
    }

    > .form {
      padding-top: 26px;
      padding-left: 50px;
      //padding-bottom: 100px;
      .submit{
        text-align: center;
        width: 123px;
        height: 40px;
        line-height: 40px;
        background: #D70D18;

        font-size: 14px;
        color: #FFFFFF;
        margin-top: 10px;
        margin-left: 230px;
      }

      .custom-kv {
        .key{
          float: left;
          width: 130px;
          font-size: 14px;
          color: #333333;
          text-align: right;
          margin-top: 13px;
          padding-right: 15px;
        }
        .val{
          float: left;
          .custom-input{
            width: 348px;
            height: 40px;
            border: 1px solid #DADADA;
            padding: 0 20px;
            input[type="text"]{
              height: 100%;
              width: 100%;
              padding: 0;
              border: none;
              outline: none;
            }
            ::v-deep.el-input__inner {
              outline: none;
              border: none;
              height: 38px;
              line-height: 38px;
              padding-left: 20px;
            }
            ::v-deep .el-icon-date{
              display: none;
            }
          }
          .custom-textarea{
            width: 428px;
            height: 50px;
            border: 1px solid #DADADA;
            textarea{
              height: 100%;
              width: 100%;
              box-sizing: border-box;
              border: none;
              outline: none;
            }
          }
          ::v-deep.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
            background-color: $color-primary;
            border-color: $color-primary;
          }
          ::v-deep.el-checkbox__inner:hover{
            border-color: $color-primary;
          }
          ::v-deep.el-checkbox__input.is-checked+.el-checkbox__label{
            color: #333333;
          }

        }
      }
    }

  }

}
.crumbs {
  width: 1200px;
  margin: 0 auto;
  padding-top: 15px;
  .location {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
  }

  .text1 {
    vertical-align: middle;
    font-size: 16px;
    color: #999999;
  }

  .text2 {
    vertical-align: middle;
    font-size: 16px;
    color: $color-primary;
  }
}

.fl {
  float: left;
  margin-right: 5px;
}
.selected {
  padding: 14px 16px;
  font-size: 16px;
  border: 2px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  color: #2c3e50;
}
.watermark-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 10;
}
</style>